import { FC, useMemo } from 'react';
import NotificationsScreensPicker from '../../components/NotificationsScreensPicker/NotificationsScreensPicker';
import { notificationsSettingLabelPostscript, NotificationsSettingType } from '../../constants/notifications';
import { INotificationSetting } from '../../types/notifications';
import { DELIVERY_METHOD } from 'src/constants/deliveryTypes';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';

interface IProps {
  type: NotificationsSettingType;
  eventPickerOptions: IPickerOption[];
  notification: INotificationSetting;
  changeNotification: (value: Partial<INotificationSetting>) => void;
}

const NotificationSettingEditTopBlock: FC<IProps> = ({ type, eventPickerOptions, notification, ...props }: IProps): JSX.Element => {
  const selectedEventPickerOptionLabel = useMemo((): string => {
    return localeStore.t(notification.event + notificationsSettingLabelPostscript[type]);
  }, [type, notification.event]);

  const selectedEventPickerOption = useMemo((): IPickerOption[] => {
    return [{ value: notification.event, label: selectedEventPickerOptionLabel }];
  }, [notification.event, selectedEventPickerOptionLabel]);

  const deliveryMethodPickerOptions = useMemo((): IPickerOption[] => {
    return [{ value: DELIVERY_METHOD.APP_NOTIFICATION, label: localeStore.t(DELIVERY_METHOD.APP_NOTIFICATION) }];
  }, []);

  const selectedDeliveryMethodPickerOption = useMemo((): IPickerOption[] => {
    return [{ value: notification.deliveryMethod, label: localeStore.t(notification.deliveryMethod) }];
  }, [notification.event]);

  const onSelectPickerOption = (field: keyof INotificationSetting) => (options: IPickerOption[]) => {
    if (!options.length) return;
    props.changeNotification({ [field]: options[0].value });
  };

  return (
    <div className="d-flex flex-row gap-20">
      <NotificationsScreensPicker
        title="event"
        selectedOptions={selectedEventPickerOption}
        options={eventPickerOptions}
        onSelectOptions={onSelectPickerOption('event')}
      />

      <NotificationsScreensPicker
        title="delivery_method"
        selectedOptions={selectedDeliveryMethodPickerOption}
        options={deliveryMethodPickerOptions}
        onSelectOptions={onSelectPickerOption('deliveryMethod')}
      />
    </div>
  );
};

export default NotificationSettingEditTopBlock;
